<script lang="ts">
	//Components
	import MediaPlayerComponent from 'src/components/MediaPlayerComponent.svelte';
	import ThermostatsG2 from '../../Settings/SettingsG2/ThermostatsWallDisplay/ThermostatsG2.svelte';

	export let device;
</script>

{#if device?.mode === 'thermostat'}
	<ThermostatsG2 {device} />
{/if}
{#if device?.mode === 'media_player'}
	<MediaPlayerComponent {device} />
{/if}
